const Button1 = (props) => {
    
    const buttonActiveClass = 'rounded-md bg-green-700 px-3 py-2 text-sm font-semibold ' +
        'text-white shadow-sm hover:bg-green-600 focus-visible:outline focus-visible:outline-2 ' +
        'focus-visible:outline-offset-2 focus-visible:outline-indigo-600';
    
    
    const buttonInactiveClass ='rounded-md bg-gray-400   px-3 py-2 text-sm font-semibold ' +
        'text-white focus-visible:outline';
    
    return(
        <button
            className={props.disabled ? buttonInactiveClass : buttonActiveClass}
            onClick={props.onclick}
            disabled={props.disabled}
        >
            {props.text}
        </button>
    );
}


export default Button1;